export const VROutlineIcon = (props) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M38.3332 28.5713C38.3332 29.8342 37.7813 31.0454 36.799 31.9384C35.8166 32.8315 34.4843 33.3332 33.0951 33.3332H26.5475C26.1409 33.3332 25.7399 33.2471 25.3762 33.0818C25.0125 32.9165 24.6962 32.6765 24.4522 32.3808L22.0951 29.5236C21.8511 29.2279 21.5348 28.9879 21.1711 28.8226C20.8074 28.6573 20.4064 28.5713 19.9998 28.5713C19.5932 28.5713 19.1922 28.6573 18.8286 28.8226C18.4649 28.9879 18.1486 29.2279 17.9046 29.5236L15.5475 32.3808C15.3035 32.6765 14.9872 32.9165 14.6235 33.0818C14.2598 33.2471 13.8588 33.3332 13.4522 33.3332H6.9046C5.51537 33.3332 4.18304 32.8315 3.20071 31.9384C2.21837 31.0454 1.6665 29.8342 1.6665 28.5713V21.4284C1.6665 20.1655 2.21837 18.9543 3.20071 18.0612C4.18304 17.1682 5.51537 16.6665 6.9046 16.6665H33.0951C34.4843 16.6665 35.8166 17.1682 36.799 18.0612C37.7813 18.9543 38.3332 20.1655 38.3332 21.4284V28.5713Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.6668 28.3332C13.5078 28.3332 15.0002 26.8408 15.0002 24.9998C15.0002 23.1589 13.5078 21.6665 11.6668 21.6665C9.82588 21.6665 8.3335 23.1589 8.3335 24.9998C8.3335 26.8408 9.82588 28.3332 11.6668 28.3332Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M29.9998 28.3332C31.8408 28.3332 33.3332 26.8408 33.3332 24.9998C33.3332 23.1589 31.8408 21.6665 29.9998 21.6665C28.1589 21.6665 26.6665 23.1589 26.6665 24.9998C26.6665 26.8408 28.1589 28.3332 29.9998 28.3332Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M38.3332 21.6665V9.75694C38.3333 9.06061 38.087 8.38464 37.6342 7.83865C37.1814 7.29266 36.5487 6.90866 35.8387 6.74891C35.1286 6.58917 34.3828 6.66304 33.7222 6.95855C33.0617 7.25407 32.525 7.7539 32.1994 8.377C31.6815 9.36594 30.8853 10.1976 29.8999 10.7787C28.9146 11.3598 27.7791 11.6674 26.6208 11.6669H13.3789C12.2206 11.6674 11.0851 11.3598 10.0997 10.7787C9.11438 10.1976 8.31813 9.36594 7.80031 8.377C7.47464 7.7539 6.93801 7.25407 6.27743 6.95855C5.61686 6.66304 4.87108 6.58917 4.16101 6.74891C3.45095 6.90866 2.81823 7.29266 2.36545 7.83865C1.91267 8.38464 1.66637 9.06061 1.6665 9.75694V21.6665"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
